import styled from 'styled-components';
import { spaceMixin, Text } from '@zillow/constellation';

export const StyledRenewContainer = styled.div`
    margin-bottom: ${spaceMixin('sm')};
    text-align: right;
`;

export const StyledBlockText = styled(Text)`
    display: inline-block;
`;
